import React from 'react'
import styled from 'styled-components'
import { Colors, Fonts, FontWeights } from '../../constants'
import { Currency } from '../../model'
import { PairSelect } from '../input'

interface Props {
  className?: string
  label: string
  currency?: Currency
  other?: Currency
  onChange?: (currency: Currency, other: Currency) => void
}

export function PageHeader({ className, label, currency, other, onChange }: Props) {
  return (
    <Content className={className}>
      <Header>{label}</Header>
      {currency && other && onChange && <PairSelect currency={currency} other={other} onChange={onChange} />}
    </Content>
  )
}

const Content = styled.header`
  padding: 0 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 58px;
  background: rgb(57, 57, 57);
  background: linear-gradient(0deg, rgba(57, 57, 57, 1) 0%, rgba(28, 28, 28, 1) 100%);
`

const Header = styled.h1`
  color: ${Colors.White};
  font-size: 20px;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Semibold};
  text-transform: uppercase;
`
